import React from 'react'
import {
    Badge,
    Box,
    IconButton,
    ListItemButton,
    ListItemIcon,
} from '@mui/material'
import {
    ActionIconsContainerDesktop,
    ActionIconsContainerMobile,
    MyList,
} from '../../styles/appbar'
// import PersonIcon from '@mui/icons-material/Person'
// import FavoriteIcon from '@mui/icons-material/Favorite'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import { Colors } from '../../styles/theme'
import { useShoppingCart } from 'context/ShoppingCartContext'
import { Link as RouterLink } from 'react-router-dom'
import ToggleCurrency from '../toggleCurrency/ToggleCurrency'
// import { config } from '../../utilities/constants'

export default function Actions({ matches }) {
    const { cart } = useShoppingCart()

    const Component = matches
        ? ActionIconsContainerMobile
        : ActionIconsContainerDesktop

    return (
        <Component>
            {matches ? (
                /*
                  MOBILE LAYOUT — bypassing MyList because its baked-in
                  `justifyContent: flex-end` was resisting override via sx.

                  Both children use TIGHT wrappers so their visible bounds
                  match the wrapper bounds. This is critical for space-evenly
                  to read as visually balanced — if either control had
                  invisible padding inside its wrapper, the eye would
                  perceive the gaps as uneven.

                  Specifically:
                  - The toggle's outline border IS its visible boundary,
                    so its wrapper just needs to contain it tightly.
                  - The cart uses an IconButton (NOT ListItemButton, NOT
                    ListItemIcon) because both default to internal padding
                    and a 56px minWidth that push the visible glyph
                    off-center within the wrapper. IconButton wraps its
                    child snugly with symmetric 8px padding all sides.

                  space-evenly distributes three TRULY equal gaps:
                  [ gap | toggle | gap | cart | gap ]
                */
                <Box
                    sx={{
                        display: 'flex',
                        flexGrow: 1,
                        width: '100%',
                        justifyContent: 'space-evenly',
                        alignItems: 'center',
                        py: 1,
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <ToggleCurrency variant="dark" />
                    </Box>

                    <IconButton
                        component={RouterLink}
                        to="/cart"
                        aria-label="View cart"
                        sx={{
                            color: Colors.companyColors.eb_bkgrnd,
                            '&:hover': {
                                backgroundColor: 'rgba(255, 255, 255, 0.08)',
                            },
                        }}
                    >
                        <Badge
                            badgeContent={cart && cart.length}
                            color="warning"
                        >
                            <ShoppingCartIcon />
                        </Badge>
                    </IconButton>
                </Box>
            ) : (
                /*
                  DESKTOP LAYOUT — unchanged. Uses ListItemButton/ListItemIcon
                  as before because the right-floated top app bar context
                  doesn't require the same tight-bounds discipline.
                */
                <MyList type="row">
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            ml: 0.8,
                        }}
                    >
                        <ToggleCurrency variant="light" />
                    </Box>

                    <ListItemButton
                        component={RouterLink}
                        to="/cart"
                        sx={{
                            justifyContent: 'center',
                            ml: 0,
                            pl: 0,
                            flex: '0 0 auto',
                        }}
                    >
                        <ListItemIcon
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                            }}
                        >
                            <Badge
                                badgeContent={cart && cart.length}
                                color="warning"
                            >
                                <ShoppingCartIcon />
                            </Badge>
                        </ListItemIcon>
                    </ListItemButton>
                </MyList>
            )}
        </Component>
    )
}
